<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="meta"
            :server-items-length="total"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50]
            }"
            :loading="isFetch"
            loading-text="Загрузка данных... Ожидайте"
    >
        <template v-slot:top>
            <v-toolbar flat dense>
                <v-spacer></v-spacer>
                <v-btn
                        icon
                        color="green"
                        @click="load"
                        :disabled="isFetch"
                >
                    <v-icon>mdi-cached</v-icon>
                </v-btn>
            </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-btn small color="primary" @click="() => $router.push({name: 'ContactEditPage', params:{jurId: item.jur_id, contactId: item.id}})">
                <v-icon>
                    mdi-note-edit-outline
                </v-icon>
            </v-btn>
            <v-btn small color="error" @click="() => onRemoveContact(item.id)">
                <v-icon>
                    mdi-delete
                </v-icon>
            </v-btn>
        </template>
    </v-data-table>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "ContactsTable",
    props:{
        initJurId: {
            type: Number,
            default: null,
            required: false
        },
    },
    mounted() {
        this.load();
    },
    data(){
        return {
            isFetch: false,
            headers: [
                {
                    text: 'Должность или титул контакта',
                    sortable: false,
                    value: 'position',
                },
                {
                    text: 'Адрес электронной почты',
                    sortable: false,
                    value: 'default_email',
                },
                {
                    text: 'Номер телефона',
                    sortable: false,
                    value: 'default_phone',
                },
                {
                    text: 'Действия',
                    sortable: false,
                    value: 'actions',
                },
            ],
            contactsData: [],
            total: 0,
            meta: {
                itemsPerPage: 10,
                page: 1,
            }
        }
    },
    watch: {
        meta: {
            handler () {
                this.load();
            },
            deep: true,
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_RESPONSE_ERROR', 'SHOW_SUCCESS']),
        async load(){
            try{
                this.isFetch = true;
                let response = {};
                if(this.initJurId){
                    let {data} = await this.getClient().getJurContacts(this.initJurId, this.meta.page, this.meta.itemsPerPage);
                    response = data;
                }else{
                    let {data} = await this.getClient().getContactAll(this.meta.page, this.meta.itemsPerPage);
                    response = data;
                }
                this.setContactsData(response.data);
                this.setMeta(response.meta);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка загрузки данных ('});
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        setContactsData(data){
            this.contactsData.splice(0, this.contactsData.length, ...data);
        },
        setMeta(meta){
            this.total = meta.total;
        },
        async onRemoveContact(contactId){
            try{
                this.isFetch = true;
                await this.getClient().contactRemove(contactId);
                this.SHOW_SUCCESS('Успешно удалено');
                this.load();
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка удаления ('});
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        }
    },
    computed: {
        ...mapGetters( 'contragents', ['getClient']),
        items(){
            return this.contactsData;
        }
    }
}
</script>

<style scoped>

</style>